import { REQUEST, RECEIVE, ADD, ADDREQUEST } from '../types/events'
import config from '../config'

function doFetch(dispatch, currentState, bezirk = null, kreis = null, fachgebiet = null, currentPhrase = null, hdblFilter = true, onlineFilter = true, offlineFilter = true,  currentDate = null) {
    dispatch({
        type: REQUEST
    })



    let limit = 15;
    if (window.bbvTermine && window.bbvTermine.limit) {
        limit = window.bbvTermine.limit;
        if (limit < 15) {
            limit = 15;
        }
    }

    if (currentDate !== null) {
        limit = 100;
    }

    let pastEvents = false;
    if (window.bbvTermine && window.bbvTermine.pastEvents) {
        pastEvents = window.bbvTermine.pastEvents;
    }

    let onlyLehrfahrten = false;
    if (window.bbvTermine && window.bbvTermine.onlyLehrfahrten) {
        onlyLehrfahrten = window.bbvTermine.onlyLehrfahrten;
    }

    return fetch(config.baseUrl+'/api/biwe/v1/veranstaltungen?bezirk='+bezirk+'&kreis='+kreis+'&fachgebiet='+fachgebiet+'&fulltext='+currentPhrase+'&hdbl='+hdblFilter+'&online='+onlineFilter+'&offline='+offlineFilter+'&date='+currentDate+'&limit='+limit+'&pastEvents='+pastEvents+'&onlyLehrfahrten='+onlyLehrfahrten)
        .then(result => result.json())
        .then(
            data => {
                dispatch({
                    type: RECEIVE,
                    currentAvailableDates: currentState.availableDates,
                    data
                });
            }
        )
}

function addEventsByPaginatedUrl(dispatch, events, url) {
    dispatch({
        type: ADDREQUEST,
        currentEvents: events
    })
    return fetch(url)
        .then(result => result.json())
        .then(
            data => {
                dispatch({
                    type: ADD,
                    currentEvents: events,
                    data
                });
            }
        )
}

function shouldFetchEvents(events) {
    return !events.isFetching;

}

export function fetchEvents() {
    return (dispatch, getState) => {
        let currentState = getState()
        let events = currentState.events
        let currentBezirk = currentState.bezirke.selected
        let currentKreis = currentState.kreise.selected
        let currentFachgebiet = currentState.fachgebiete.selected
        let currentPhrase = currentState.filters.phrase
        let currentHdbl = currentState.filters.hdbl
        let currentOnline = currentState.filters.online
        let currentOffline = currentState.filters.offline
        let currentDate = currentState.filters.date
        if (shouldFetchEvents(events)) {
            return doFetch(dispatch, currentState, currentBezirk, currentKreis, currentFachgebiet, currentPhrase, currentHdbl, currentOnline, currentOffline, currentDate)
        }
    }
}

export function appendEventsNextPageAction(page) {
    return (dispatch, getState) => {
        let currentState = getState()
        let events = currentState.events.list.data
        return addEventsByPaginatedUrl(dispatch, events, page)
    }
}



// WEBPACK FOOTER //
// ./src/actions/events.js